import * as sell from 'model/actions/utilities/_sell';
import { formatMessage } from 'model/message';

const MAX_SELL_WATER = 20;

const messageText = ({ cost, gain }) => {
  return formatMessage('sold water', { cost, gain });
};

const value = (max, resultsVariable) => (resultsVariable ? Math.floor(Math.random() * max) : max);

const attempt = (price, resultsVariable) => {
  const cost = {
    water: value(MAX_SELL_WATER, resultsVariable)
  };
  return sell.attempt(cost, price);
};

const sellWater = ({ context, resultsVariable }) => {
  // TODO: Use maxQuantity to limit the amount that the merchant will buy
  const [maxQuantity, price] = sell.adjustQuantityAndCost(context, 'water');

  return {
    title: 'Sell Water',
    cooldown: 0.2,
    enabled: () => context.party.resources.attribs.water.value >= MAX_SELL_WATER,
    execute: context => {
      const result = attempt(price, resultsVariable);

      sell.executeSideEffects(context, result);

      return { result: { message: messageText(result) } };
    },
    tooltips: [['coins', `${price}`]]
  };
};

export default sellWater;
